import {
	fetchContestsHistoryFailed,
	fetchContestsHistorySuccess
} from 'apps/BWW_TRIVIA/modules/actions/contests_history_trivia';
import {getTriviaContestsHistoryCommon} from 'apps/BWW_TRIVIA/modules/selectors/contests_history_trivia';
import {globalError} from 'modules/actions/errors';
import {Api} from 'modules/utils/Api';
import {call, put, select} from 'typed-redux-saga';
import {isEqual} from 'lodash';

export const fetchContestsHistorySaga = function* () {

	try {
		const contests_history = yield* call(Api.JSON.contests_history);
		const contests = yield* select(getTriviaContestsHistoryCommon)

		if (!isEqual(contests, contests_history)) {
			yield put(fetchContestsHistorySuccess(contests_history || []));
		}
	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error));
		yield put(fetchContestsHistoryFailed(error));
	}
};
